import { PaymentDto } from '../dtos';
import { PaymentType } from '../enums';

export class PaymentBuilder {
  private payment: PaymentDto;

  constructor() {
    this.payment = new PaymentDto();
  }

  public setId(id: number): PaymentBuilder {
    this.payment.id = id;
    return this;
  }

  public setName(name: string): PaymentBuilder {
    this.payment.name = name;
    return this;
  }

  public setCurrency(currency: number): PaymentBuilder {
    this.payment.currency = currency;
    return this;
  }

  public setReceipts(receipts: number[]): PaymentBuilder {
    this.payment.receipts = receipts;
    return this;
  }

  public setPaymentType(paymentType: PaymentType): PaymentBuilder {
    this.payment.paymentType = paymentType;
    return this;
  }

  public build(): PaymentDto {
    return this.payment;
  }
}
